import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Navigate } from 'react-router-dom';
import { signIn, verify, signUp, confirmAgent, closeErrorMsg, closeCode } from "../../redux/modules/auth";
import InputField from "../common/input-field"
import { useForm } from "../../hooks/use-form";
import PopupMsg from "../common/popup-msg"

function Verification(props) {
  const dispatch = useDispatch();
  const auth = useSelector(state => state.auth);
  const mobile = useSelector(state => state.mobile);
  const [over, setOver] = useState(false);
  const [[m, s], setTime] = useState([0, 20]);

  const [fields, setValue, setFieldValid, formIsValid, trigger, setTrigger, setValidate, setCheckValue, setAddress, setInn, setValueSelect, clearForm, ] = useForm({
    code: {
      value: '',
      name: 'code',
      type: 'text',
      placeholder: '0000',
      validate: 'code',
      valid: false,
      valid_reg: true
    }
  }, []);


  const handleSubmit = (e) => {
    if(e) e.preventDefault();

    if (fields.code.value.length === 4 && formIsValid()) {
      if(auth.is_loggined) {
        dispatch(
          verify({
            cmd: 'authorization-authorize',
            phone: auth.user.phone,
            code: fields.code.value,
            //ReturnDebugData: true
          }
        ))
      }
      if(auth.is_registered) {
        dispatch(
          confirmAgent({
            cmd: 'agents-confirm',
            phone: auth.user.phone,
            code: fields.code.value,
            //ReturnDebugData: true
          }
        ))
      }
    } 
  };

  const keyUp = () => {
    if(auth.error) dispatch(closeErrorMsg());
    if(fields.code.value.length === 4) handleSubmit()
  }

  const tick = () => {
    if (over) return;

    if (m === 0 && s === 0) {
      setOver(true);
    } else if (s == 0) {
      setTime([59, 59]);
    } else {
      setTime([m, s - 1]);
    }
  };

  const reset = () => {
    setTime([0, 20]);
    setOver(false);
    clearForm()

    if(auth.is_loggined) {
      dispatch(
        signIn({
          cmd: 'authorization-code',
          //ReturnDebugData: true,
          phone: auth.user.phone
        })
      )
    }
    if(auth.is_registered) {
      dispatch(
        signUp({
          cmd: 'agents-add',
          ...auth.user,
          //ReturnDebugData: true,
        })
      )
    }
  };

  useEffect(() => {
    document.title = 'Подтверждение номера | Личный кабинет Брокера THE FIVE';

    const timerID = setInterval(() => tick(), 1000);
    return () => clearInterval(timerID);
  });

  const getVal = text => {
    return (text[0] + ' ' + text[1] + text[2] + text[3] + ' ' +  + text[4] + text[5] + text[6] + ' ' + text[7] + text[8] + ' ' + text[9] + text[10])
  }
  
  if(!auth.user) {
    return <Navigate to='/login' replace />
  }
  
  if(auth.is_veryfied && auth.is_loggined) {
    return <Navigate to='/' replace />
}
  
  return (
    <>
      <div className="page page-auth">
        <div className="page-auth__img"></div>
        {mobile && <div className="logo"></div>}
        <div className="page-auth__content">
        {!mobile && <div className="logo"></div>}

          <form className={auth.error ? "form form_verify form_error fadeIn" : "form form_verify fadeIn"} onSubmit={handleSubmit} noValidate>
            <div className="form__title">Код подтверждения</div>
            <div className="form__text">На указанный номер +{getVal(auth.user.phone)}<br/>отправлено СМС с кодом. Введите код</div>
            <InputField
              trigger={trigger}
              setFieldValid={setFieldValid}
              setValue={setValue}
              keyUp={keyUp}
              {...fields.code}
            />
            <div className="form__error">Введен неверный код.<br/>Проверьте правильность введения.</div>
            {!over && <div className="form__timeout">Отправить код повторно через {`${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`}</div>}
            {over && <button type="button" className="btn" onClick={() => reset()}>Отправить смс повторно</button>}
          </form>
                    
        </div>
      </div>    
      {auth.code && <PopupMsg message={auth.code} close={closeCode()} />}
    </>
  );
}
export default Verification;